/** Helpers of the refine row: which filters the quick chips own and how they edit the filter state. */
import type { SearchRequest } from './api';

export type Filter = NonNullable<SearchRequest['filter']>;

/** Filter keys the quick chips own; the remaining active filters are listed as removable chips. */
export const QUICK_FILTER_KEYS: ReadonlySet<string> = new Set(['hasAttachments', 'unread', 'received', 'from']);

export interface ActiveFilterChip {
  key: string;
  name: string;
  shown: string;
}

/** Date presets of the refine row, in days back from today. */
export const DATE_PRESETS = [
  { id: 'today', days: 0 },
  { id: 'week', days: 7 },
  { id: 'month', days: 30 },
  { id: 'year', days: 365 },
] as const;

/** `YYYY-MM-DD` of the local day `days` ago (what the date filter takes). */
export function dateDaysAgo(days: number, now = new Date()): string {
  const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() - days);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/** The filter with `key` set to `value`, or removed when `value` is undefined. */
export function withFilter(filter: Filter, key: keyof Filter, value: unknown): Filter {
  const next: Record<string, unknown> = { ...filter };
  if (value === undefined) delete next[key];
  else next[key] = value;
  return next;
}
